module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/banner/zh-hans-37c27286a935b103588d19dc4cb0d478.jpg";